import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ProductIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_562_1764)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.81348 14.925H2.06348C1.66565 14.925 1.28412 14.767 1.00282 14.4858C0.721512 14.2044 0.563477 13.8229 0.563477 13.425V2.07983C0.563477 1.68201 0.721512 1.30048 1.00282 1.01918C1.28412 0.737869 1.66565 0.579834 2.06348 0.579834H15.5635C15.9613 0.579834 16.3428 0.737869 16.6241 1.01918C16.9055 1.30048 17.0635 1.68201 17.0635 2.07983V7.05008",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M0.563477 4.16626H17.0635",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.4385 15.4921L12.9385 17.4204V12.2776L17.4385 10.3494V15.4921Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.43799 15.4921L12.938 17.4204V12.2776L8.43799 10.3494V15.4921Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.938 8.42017L17.438 10.3492L12.938 12.2774L8.43799 10.3492L12.938 8.42017Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_562_1764",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
